/** Shared types for AI Workflow components */

export const BACKGROUND_CATEGORIES = [
  { value: 'random', label: 'All' },
  { value: 'solid', label: 'Solid' },
  { value: 'classic', label: 'Classic' },
  { value: 'luxury', label: 'Luxury' },
  { value: 'office', label: 'Office' },
  { value: 'outdoor', label: 'Outdoor' },
  { value: 'indoor', label: 'Indoor' },
];

export interface ModelTemplate {
  id: string;
  name: string;
  imageUrl: string;
  category: string;
  gender: string;
}

export interface BackgroundPreset {
  backgroundId: string;
  imageUrl: string;
  category: string;
  liveStatus: boolean;
}

export interface PosePreset {
  poseId: string;
  imageUrl: string | string[];
  prompt: string;
  type: string;
  gender: string;
  poseName?: string;
  liveStatus?: boolean;
}

/** Payload shape for catalogue generator – backend uses poseId, prompt, type, gender */
export interface CataloguePoseData {
  poseId: string;
  prompt: string;
  type: string;
  gender: string;
}
